/**
 * Amplitude Feature Flag Experiment 'feature key' constants
 */
export const AmplitudeExperiments = {
    AverageLotValueActionCalendarRanking: 'sear-1266-alv-auction-calendar-ranking',
    ElasticOnCategoryPages: 'sear-641-use-of-elastic-on-category-pages',
    ExposureVsPageViewedCheck: 'exposure-vs-page-viewed-check',
    HomePageRedesign: 'sear-1758-home-page-redesign',
    ItemPageDiscoverMoreFromThisAuction: 'laac-1126-item-page-discover-more-from-this-auction',
    MyItemsHoverMenu: 'laac-1947-my-items-hover-menu',
    NewCatalogPageBanner: 'laac-2111-new-catalog-page-banner',
    // new bidding console experiment
    NewBiddingConsole: 'laac-1705-live-bidding-console-phase1-v3',
    NoReservePriceBadge: 'la-display-no-reserve-message',
    PopularityScoreReRanking: 'sear-1021-popularity-score-re-ranking-v2',
    PriceResultsRedesign: 'sear-1973-price-results-redesign',
    PurchaseProtectionMessaging: 'ups-4437',
    SearchResultsAdExperiment: 'ups-4049',
    SearchTileLiveLotPosition: 'sear-1971-search-tile-live-lot-position',
    // User sees "next steps" information on the new confirmation page
    ShippingNextStepsExperiment: 'ups-5084',
    SimilarLotsUnifiedClip: 'sear-1381-similar-lots-unified-clip',
    SimplifiedCategoryPage: 'simplified-category-page',
    VariantJumpingHomePageCheck: 'variant-jumping-home-page-check',
    VipConfirmation: 'laac-2136-vip-confirmation',
} as const;

export type AmplitudeExperimentIds = (typeof AmplitudeExperiments)[keyof typeof AmplitudeExperiments];

export const AmplitudeVariants: {
    [key in keyof typeof AmplitudeExperiments]: {
        [variant: string]: string;
        Control: 'control';
        Treatment?: 'treatment';
    };
} = {
    AverageLotValueActionCalendarRanking: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ElasticOnCategoryPages: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ExposureVsPageViewedCheck: {
        Control: 'control',
        Off: 'off',
        Treatment: 'treatment',
    },
    NewCatalogPageBanner: {
        Control: 'control',
        Treatment: 'treatment',
    },
    HomePageRedesign: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ItemPageDiscoverMoreFromThisAuction: {
        Control: 'control',
        Treatment: 'treatment',
    },
    MyItemsHoverMenu: {
        Control: 'control',
        Treatment: 'treatment',
    },
    NewBiddingConsole: {
        Control: 'control',
        Treatment: 'treatment',
    },
    NoReservePriceBadge: {
        Control: 'control',
        Treatment: 'treatment',
    },
    PopularityScoreReRanking: {
        AddPopularityKeepingBidCount: 'treatmenta',
        AddPopularityRemovingBidCount: 'treatmentb',
        Control: 'control',
    },
    PriceResultsRedesign: {
        Control: 'control',
        Treatment: 'treatment',
    },
    PurchaseProtectionMessaging: {
        Control: 'control',
        Treatment: 'treatment',
    },
    SearchResultsAdExperiment: {
        Control: 'control',
        NewDesign: 'new-design',
    },
    SearchTileLiveLotPosition: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ShippingNextStepsExperiment: {
        Control: 'control',
        SeeShippingSteps: 'treatment',
    },
    SimilarLotsUnifiedClip: {
        Control: 'control',
        Treatment: 'treatment',
    },
    SimplifiedCategoryPage: {
        Control: 'control',
        Treatment: 'treatment',
    },
    VariantJumpingHomePageCheck: {
        Control: 'control',
        Treatment: 'treatment',
    },
    VipConfirmation: {
        Control: 'control',
        Treatment: 'treatment',
    },
} as const;

export type AmplitudeExperimentsVariantIds = (typeof AmplitudeVariants)[keyof typeof AmplitudeVariants];
